import React from "react";
import Slider from "react-slick";

const PlatformLists = [
    {
        id: 1,
        icon: "/img/integrate/etl_icon01.svg",
        select_icon: "/img/integrate/etl_select_icon01.svg",
        title: "어디서든 데이터 수집",
        detail: "수백 개의 사전 구축된 커넥터와 고도로 커스터마이징 가능한 \n" +
            "Universal REST API 커넥터를 제공합니다."
    },
    {
        id: 2,
        icon: "/img/integrate/etl_icon02.svg",
        select_icon: "/img/integrate/etl_select_icon02.svg",
        title: "데이터 변환",
        detail: "220개 이상의 로우코드(low-code) 기반 데이터 변환 옵션으로 \n" +
            "다양한 요구사항에 대응할 수 있습니다."
    },
    {
        id: 3,
        icon: "/img/integrate/etl_icon03.svg",
        select_icon: "/img/integrate/etl_select_icon03.svg",
        title: "스케줄링",
        detail: "코드 없이 반복 스케줄을 설정하거나, Cron 표현식을 활용해 \n" +
            "더욱 고도화된 스케줄링이 가능합니다."
    },
    {
        id: 4,
        icon: "/img/integrate/etl_icon04.svg",
        select_icon: "/img/integrate/etl_select_icon04.svg",
        title: "로직 및 의존성 설정",
        detail: "파이프라인 간 로직과 의존성을 설정할 수 있습니다. \n" +
            "요구사항에 맞춰 SQL 쿼리와 파이프라인을 지정된 순서대로 \n" +
            "실행할 수 있습니다."
    },
]

const PlatformImages = [
    {
        id: 1,
        img: "/img/integrate/etl_con01.png"
    },
    {
        id: 2,
        img: "/img/integrate/etl_con02.png"
    },
    {
        id: 3,
        img: "/img/integrate/etl_con03.png"
    },
    {
        id: 4,
        img: "/img/integrate/etl_con04.png"
    },
]

export default class Slick extends React.Component {
  render() {
      const settings = {
          customPaging: function (index: number) {
              return (
                  <div
                      className="slider-box flex flex-col items-start justify-start">
                      <h2 className="flex flex-row items-center gap-2 text-body font-semibold text-white">
                          <img src={PlatformLists[index].icon} alt="" className="default w-6 md:w-7"/>
                          <img src={PlatformLists[index].select_icon} alt="" className="selected w-7"/>
                          {PlatformLists[index].title}
                      </h2>
                      <p className="max-w-md tracking-tight mt-1 text-body text-white text-left">{PlatformLists[index].detail}</p>
                  </div>
              );
          },
          dots: true,
          dotsClass: "slick-dots slick-thumb",
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          autoplay: true,
          autoplaySpeed: 3000
      };
      return (
          <Slider {...settings}>
              {PlatformImages.map(list => (
                  <img key={list.id} src={list.img} alt="" className="etl_con_img" />
              ))}
          </Slider>
      );
  }
}
// export default Slick;